import { useState, useContext } from "react";
import Modal from "../modal";
import LanguageContext from "../../context/language";
import Error from "../error";

const DeleteCommentModal = ({ show, setShow, commentId, deleteComment, onUpdate }) => {
  const { labels } = useContext(LanguageContext);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(false);

  const handleDeleteComment = async () => {
    setDeleting(true);
    try {
      await deleteComment(commentId);
      onUpdate(commentId);
      setShow(false);
    } catch (err) {
      console.error("Error deleting comment: ", err);
      setError(true);
    }
    setDeleting(false);
  };

  return (
    <Modal show={show} setShow={setShow} className="intranet-modal--warning">
      <div className="intranet-modal__title">
        {labels?.DELETE_COMMENT_WARNING || "Delete comment?"}
      </div>

      <div className="intranet-modal__buttons">
        <button className="button tertiary" onClick={() => setShow(false)}>
          {labels?.NO_KEEP_IT || "No, keep it"}
        </button>
        <button className="button primary" onClick={handleDeleteComment}>
          {deleting ? <span className="loading-spinner" /> : null}
          <span>{labels?.YES_DELETE || "Yes, delete"}</span>
        </button>
      </div>
      {error && (
        <Error msg={labels?.ERROR_DELETING_COMMENT || "Error deleting comment"} variant="small" />
      )}
    </Modal>
  );
};

export default DeleteCommentModal;
